import { useEffect } from 'react';
import {
  usePersonalInsurancePendingSummary,
  portalRoleShowsPersonalInsuranceReview,
} from '../hooks/usePersonalInsurancePendingSummary';

export default function Personalinsurancenavsync({ user, onCount }) {
  const groups = user?.signInUserSession?.accessToken?.payload?.['cognito:groups'];
  const role = Array.isArray(groups) && groups.length > 0 ? groups[0] : null;
  const enabled = portalRoleShowsPersonalInsuranceReview(role);
  const { totalPending, refresh } = usePersonalInsurancePendingSummary({ enabled });

  useEffect(() => {
    onCount(totalPending);
  }, [totalPending, onCount]);

  useEffect(() => {
    const handler = () => refresh();
    window.addEventListener('personal-insurance-review-changed', handler);
    return () => window.removeEventListener('personal-insurance-review-changed', handler);
  }, [refresh]);

  return null;
}

export function notifyPersonalInsuranceReviewChanged() {
  window.dispatchEvent(new Event('personal-insurance-review-changed'));
}
